// Bundle & Save: one-click add both products to cart, reusing Dawn's cart drawer.
// Improved error handling: shows the REAL failure reason instead of a generic
// "Unavailable", and always re-enables the button so the user can retry.
(function () {
  'use strict';

  function getCartDrawer() {
    var el = document.querySelector('cart-drawer');
    if (el && typeof el.renderContents === 'function') return el;
    return null;
  }

  function addBundleToCart(items, btn) {
    var drawer = getCartDrawer();
    var payload = {
      items: items,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    };

    var original = btn ? btn.textContent : 'Add bundle to cart';
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-loading');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      // Read both HTTP status and parsed body so we catch Cloudflare/network
      // challenges that still arrive as a response.
      .then(function (r) {
        return r.json().then(
          function (body) { return { ok: r.ok, status: r.status, body: body }; },
          function () { return { ok: r.ok, status: r.status, body: null }; }
        );
      })
      .then(function (data) {
        var res = data.body || {};
        var failed = !data.ok || res.status || res.message || res.error || res.description;

        if (failed) {
          var reason = res.message || res.description || res.error ||
                       ('HTTP ' + data.status);
          console.error('[Bundle] add failed:', data.status, res);
          if (btn) {
            btn.textContent = (reason || 'Unavailable').slice(0, 48);
          }
          // Re-enable so the user can retry; restore label after a moment.
          resetBtn(btn, original, 3500);
          return;
        }

        if (drawer) {
          drawer.renderContents(res); // renders sections AND opens the drawer
        } else {
          window.location.href = '/cart';
        }
        if (btn) {
          btn.textContent = 'Added \u2713';
          resetBtn(btn, original, 1800);
        }
      })
      .catch(function (err) {
        // Network / Cloudflare challenge / non-JSON response lands here.
        console.error('[Bundle] request error:', err);
        if (btn) {
          btn.textContent = 'Network error \u2013 retry';
          resetBtn(btn, original, 3500);
        }
      });
  }

  function resetBtn(btn, original, delay) {
    if (!btn) return;
    setTimeout(function () {
      btn.textContent = original;
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }, delay || 1800);
  }

  function handle(trigger, btn) {
    var card = trigger.closest('.homepage-bundles__card');
    if (!card) return;
    var v1 = card.dataset.variant1;
    var v2 = card.dataset.variant2;
    var qty = parseInt(card.dataset.quantity || '1', 10) || 1;
    var items = [];
    if (v1) items.push({ id: parseInt(v1, 10), quantity: qty });
    if (v2) items.push({ id: parseInt(v2, 10), quantity: qty });
    if (items.length) addBundleToCart(items, btn);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bundle-add]');
    if (!trigger) return;
    e.preventDefault();
    var btn = trigger.classList.contains('homepage-bundles__cta')
      ? trigger
      : trigger.closest('.homepage-bundles__card').querySelector('.homepage-bundles__cta');
    handle(trigger, btn);
  });
})();
